import React from "react";
import { UserMenuContext } from "../context/user-menu-context";
export var useUserMenu = function () {
  return React.useContext(UserMenuContext) || {};
};